import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import LoadingButton from './utils/Loading';
import LoadingAction from "./utils/LoadingAction";
import icon1 from '../assets/imgs/responsive.png';
import icon2 from '../assets/imgs/API.png'
import icon3 from '../assets/imgs/landing-page.png';
import icon4 from '../assets/imgs/CWAD.png';
import icon5 from '../assets/imgs/UX-UI.png';
import icon6 from '../assets/imgs/mern.png';
import icon7 from '../assets/imgs/Website Maintenance.png';
import icon8 from '../assets/imgs/Deployment & Hosting.png';

const Service = () => {
  const [viewAllLoading, setViewAllLoading] = useState(false); 
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } 
    }
  }, [location]);

    useEffect(() => {
        AOS.init({
            duration: 1500,
            once: true,
        })
    }, [])

    return (
    <section className="section" id="services">
        <div className="container text-center">
            <p className="section-subtitle" data-aos="fade-right">What I Do ?</p>
            <h6 className="section-title mb-6" data-aos="fade-right">Service</h6>

            <div className="swiper-wrapper-container">
                <div 
                    className="swiper-button-prev"
                    data-aos="fade-right"
                ></div>
                <Swiper 
                    modules={[Navigation]}
                    navigation={{
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                    }}
                    spaceBetween={10}
                    slidesPerView={4}
                    loop={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        426: { slidesPerView: 2 },
                        768: { slidesPerView: 3 },
                        1024: { slidesPerView: 4 },
                    }}
                    data-aos="fade-right"
                >
                    {[{
                        icon: icon1, title: "Business Website Development", subtitle: "Modern, responsive business websites tailored to your brand and goals."
                    }, {
                        icon: icon3, title: "Landing Page Development", subtitle: "High-converting landing pages for products, startups, and marketing campaigns."
                    }, {
                        icon: icon6, title: "MERN Stack Web Application", subtitle: "Full-stack web applications using MongoDB, Express.js, React.js, and Node.js."
                    }, {
                        icon: icon2, title: "REST API Development & Integration", subtitle: "Secure REST APIs and third-party API integration for modern applications." 
                    }, {
                        icon: icon4, title: "Admin Dashboard Development", subtitle: "Secure dashboards with authentication, analytics, and data management."
                    }, {
                        icon: icon5, title: "Figma to Responsive Website", subtitle: "Convert Figma designs into clean, responsive, and pixel-perfect websites."
                    }, {
                        icon: icon7, title: "Website Maintenance", subtitle: "Bug fixes, updates, performance improvements, and ongoing technical support."
                    }, {
                        icon: icon8, title: "Deployment & Hosting", subtitle: "Deploy websites on Vercel, Netlify, Render, and configure custom domains."
                    }
                ].map((service, index) => (
                        <SwiperSlide key={index}>
                            <div className="service-card">
                                <div className="body">
                                    <img src={service.icon} alt="icon" className="icon" />
                                    <h6 className="title">{service.title}</h6>
                                    <p className="subtitle">{service.subtitle}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            
                <div 
                    className="swiper-button-next"
                    data-aos="fade-right"
                ></div>
            </div>

            <div data-aos="fade-up">
                <LoadingButton
                    isLoading={viewAllLoading}
                    onClick={() => 
                        LoadingAction(
                            setViewAllLoading,
                            () => navigate("/services-page")
                        )
                    }
                    className="btn btn-primary rounded-pill px-3 shadow mt-3"
                >
                    View All Services
                </LoadingButton>
            </div>
        </div>
    </section>
    );
}

export default Service ;